import { OptimizedScenario } from "modules/checkout/types/optimizedCart";

export function getTotalsFromScenario(scenario:OptimizedScenario, bestStore?:boolean, theoreticalValues?:boolean):{totalPurchase:number, deliveryTotal:number, totalSaving:number,storeCount:number, productsCount:number, productsCountUnmet:number, totalUnmetCost:number, cheapestStoreId:number, theoreticalDelivery:number} {
    const {store_resume, opt_cart } = scenario;
    
    // Pre-calculate product counts for each store
    const storeProductCounts = new Map<number, number>();
    if (store_resume && opt_cart) {
        store_resume.forEach(store => {
            const count = opt_cart.reduce((acc, product) => {
                const storeComponents = product.price_component.filter(pc => pc.id === store.id && !pc.no_met_conditions);
                return acc + storeComponents.reduce((sum, pc) => sum + pc.quantity, 0);
            }, 0);
            storeProductCounts.set(store.id, count);
        });
    }

    // Obtener el store_id priorizando orden completa y luego menor precio
    const cheapestStoreId = store_resume?.reduce((bestStore, currentStore) => {
        if (!bestStore) return currentStore;

        // Si la tienda actual completa la orden y la mejor hasta ahora no, la actual es mejor
        if (currentStore.order_complete && !bestStore.order_complete) {
            return currentStore;
        }
        // Si la mejor hasta ahora completa la orden y la actual no, la mejor se mantiene
        if (!currentStore.order_complete && bestStore.order_complete) {
            return bestStore;
        }

        // Si ambas completan la orden, comparamos precios
        if (currentStore.order_complete && bestStore.order_complete) {
            const currentTotal = currentStore.sub_total_theoretical + currentStore.delivery;
            const bestTotal = bestStore.sub_total_theoretical + bestStore.delivery;
            return currentTotal < bestTotal ? currentStore : bestStore;
        }
        
        // Si ninguna completa la orden, priorizamos la que tenga más productos encontrados
        const currentCount = storeProductCounts.get(currentStore.id) || 0;
        const bestCount = storeProductCounts.get(bestStore.id) || 0;

        if (currentCount !== bestCount) {
            return currentCount > bestCount ? currentStore : bestStore;
        }

        // Si tienen la misma cantidad de productos, comparamos precios
        const currentTotal = currentStore.sub_total_theoretical + currentStore.delivery;
        const bestTotal = bestStore.sub_total_theoretical + bestStore.delivery;
        
        return currentTotal < bestTotal ? currentStore : bestStore;
    }, store_resume?.[0])?.id;

    const totalPurchase = store_resume?.reduce((prev,item) => {
        return prev + item.sub_total;
    },0); 

    const totalTheoretical = store_resume?.filter(store => theoreticalValues ? store.id===cheapestStoreId : true).reduce((prev,item) => {
        return prev + item.sub_total_theoretical;
    },0); 

    const deliveryTotal = store_resume?.filter(store => theoreticalValues ? store.id===cheapestStoreId : true).reduce((acc, item) => {
        return acc + item.delivery;
    },0); 

    const totalSaving = Math.max(opt_cart?.reduce((acc,item)=>{
        acc += item.price_component.filter(pc => !pc.no_met_conditions).reduce((prev,pc) => {
            return prev + (pc.worst_price - pc.price);
        },0); 
        return acc;
    },0) ,0);

    const productsCount = bestStore ? 
        opt_cart?.reduce((acc, product) => {
            const storeComponents = product.price_component.filter(pc => pc.id === cheapestStoreId && !pc.no_met_conditions);
            const storeQuantity = storeComponents.reduce((sum, pc) => sum + pc.quantity, 0);
            return acc + storeQuantity;
        }, 0) ?? 0 
        : opt_cart?.reduce((acc, product) => {
            const totalQuantity = product.price_component.filter(pc => !pc.no_met_conditions).reduce((sum, pc) => sum + pc.quantity, 0);
            return acc + totalQuantity;
        }, 0) ?? 0;

    const productsCountUnmet = bestStore ? 
        opt_cart?.reduce((acc, product) => {
            const storeComponents = product.price_component.filter(pc => pc.id === cheapestStoreId && pc.no_met_conditions);
            const storeQuantity = storeComponents.reduce((sum, pc) => sum + pc.quantity, 0);
            return acc + storeQuantity;
        }, 0) ?? 0 
        : opt_cart?.reduce((acc, product) => {
            const totalQuantity = product.price_component.filter(pc => pc.no_met_conditions).reduce((sum, pc) => sum + pc.quantity, 0);
            return acc + totalQuantity;
        }, 0) ?? 0;

    const totalUnmetCost = bestStore ? 
        opt_cart?.reduce((acc, product) => {
            const storeComponents = product.price_component.filter(pc => pc.id === cheapestStoreId && pc.no_met_conditions);
            const storeCost = storeComponents.reduce((sum, pc) => sum + (pc.price), 0);
            return acc + storeCost;
        }, 0) ?? 0 
        : opt_cart?.reduce((acc, product) => {
            const totalCost = product.price_component.filter(pc => pc.no_met_conditions).reduce((sum, pc) => sum + (pc.price), 0);
            return acc + totalCost;
        }, 0) ?? 0;

    const storeCount = store_resume?.length ?? 0;

    const theoreticalDelivery = store_resume?.find(store => store.id === cheapestStoreId)?.theoretical_delivery ?? 0;

    return {totalPurchase: theoreticalValues ? totalTheoretical : totalPurchase, deliveryTotal, totalSaving, storeCount, productsCount, productsCountUnmet, totalUnmetCost, cheapestStoreId: cheapestStoreId ?? 0, theoreticalDelivery};
}